// Ingestion Executions Actions
const action = "INGESTION_EXECUTIONS";

// List executions actions
export const LIST_REQUEST = action + '_LIST_REQUEST';
export const LIST_SUCCESS = action + '_LIST_SUCCESS';
export const LIST_FAILURE = action + '_LIST_FAILURE';

// Get execution details actions
export const GET_REQUEST = action + '_GET_REQUEST';
export const GET_SUCCESS = action + '_GET_SUCCESS';
export const GET_FAILURE = action + '_GET_FAILURE';

// Cancel execution actions
export const CANCEL_REQUEST = action + '_CANCEL_REQUEST';
export const CANCEL_SUCCESS = action + '_CANCEL_SUCCESS';
export const CANCEL_FAILURE = action + '_CANCEL_FAILURE';

// Retry execution actions
export const RETRY_REQUEST = action + '_RETRY_REQUEST';
export const RETRY_SUCCESS = action + '_RETRY_SUCCESS';
export const RETRY_FAILURE = action + '_RETRY_FAILURE';

// Get statistics actions
export const STATS_REQUEST = action + '_STATS_REQUEST';
export const STATS_SUCCESS = action + '_STATS_SUCCESS';
export const STATS_FAILURE = action + '_STATS_FAILURE';

// Clear state action
export const CLEAR = action + '_CLEAR';

// Action creators
export const listExecutions = (payload = {}) => ({
  type: LIST_REQUEST,
  payload
});

export const listExecutionsSuccess = (response) => ({
  type: LIST_SUCCESS,
  payload: response
});

export const listExecutionsFailure = (error) => ({
  type: LIST_FAILURE,
  payload: error
});

export const getExecution = (executionId) => ({
  type: GET_REQUEST,
  payload: { executionId }
});

export const getExecutionSuccess = (response) => ({
  type: GET_SUCCESS,
  payload: response
});

export const getExecutionFailure = (error) => ({
  type: GET_FAILURE,
  payload: error
});

export const cancelExecution = (executionId) => ({
  type: CANCEL_REQUEST,
  payload: { executionId }
});

export const cancelExecutionSuccess = (response) => ({
  type: CANCEL_SUCCESS,
  payload: response
});

export const cancelExecutionFailure = (error) => ({
  type: CANCEL_FAILURE,
  payload: error
});

export const retryExecution = (executionId) => ({
  type: RETRY_REQUEST,
  payload: { executionId }
});

export const retryExecutionSuccess = (response) => ({
  type: RETRY_SUCCESS,
  payload: response
});

export const retryExecutionFailure = (error) => ({
  type: RETRY_FAILURE,
  payload: error
});

export const getExecutionStats = () => ({
  type: STATS_REQUEST
});

export const getExecutionStatsSuccess = (response) => ({
  type: STATS_SUCCESS,
  payload: response
});

export const getExecutionStatsFailure = (error) => ({
  type: STATS_FAILURE,
  payload: error
});

export const clearState = () => ({
  type: CLEAR
});
